import { render, staticRenderFns } from "./BeforeFormHeader.vue?vue&type=template&id=3cf355e3&scoped=true"
import script from "./BeforeFormHeader.vue?vue&type=script&lang=js"
export * from "./BeforeFormHeader.vue?vue&type=script&lang=js"
import style0 from "./BeforeFormHeader.vue?vue&type=style&index=0&id=3cf355e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf355e3",
  null
  
)

export default component.exports